// 获取i车币事件上报
import cheCoinMallApp from '../../apis/ics.ccm.api';

// data: JSON格式
// 通话大于等于30s，且使用了带看工具
const taskIdsOfDtsActions = [
  '360car_frame_index_change',
  'vr_color_click',
  'arhall_scenelist_click',
  'arhall_scenearrow_click',
];
// 通话大于等于30s，且使用留资工具
const taskIdsOfOrderActions = [
  'dlr_vr_b_fasonghongbao_click',
  'ZNZT-vrdk-app_subject_003',
  'car360_vr_rtc_sales_sendOrder',
  'ZNCP-JH-m_click_106',
  'ZNCP-JH-m_click_107',
  'ZNCP-JH-m_click_104',
  'ZNCP-JH-m_click_108',
  'ZNCP-JH-m_click_105',
  'dlr_b_vr_beiwanglu_tijiao_click',
];
export function reportCoin(data) {
  let taskId = 0;
  const action = data.action;
  if (taskIdsOfDtsActions.includes(action)) {
    taskId = 100101;
  }
  if (taskIdsOfOrderActions.includes(action)) {
    taskId = 100102;
  }

  if (taskId > 0) {
    cheCoinMallApp
      .getCoinCeportOpt({
        channelId: data.channelId,
        taskId,
        eventCode: data.action,
      })
      .catch((error) => {
        console.log(' 获取i车币事件上报异常：', JSON.stringify(error));
      });
  }
}
